<div class="canvas-tools-container">
  <gb-token-color-picker
    circleDiameter="38px"
    [control]="backgroundColorFormControl"
    labelTranslateKey="PRESENTER.BACKGROUND_COLOR"
    (colorPickerClose)="backgroundColorChange.emit($event)"
    cpPosition="right"
    [showDropdown]="true"
  ></gb-token-color-picker>

  <gb-image-upload-button
    labelText="PRESENTER.BACKGROUND"
    buttonText="SELECT_IMAGE"
    backdropColor="var(--gb-background-color-500)"
    [showEmptyImageArea]="true"
    (openUploadDialog)="openBackgroundImageUploadDialog.emit()"
    [images]="backgroundImages"
    [maxWidth]="4000"
    [maxHeight]="2000"
    [cover]="true"
    [isMulti]="false"
    [secondaryButtonText]="backgroundImages?.length ? 'CLEAR' : ''"
    (secondaryButtonClicked)="clearBackgroundImage.emit()"
  >
    @if (backgroundImages?.length) {
      <mat-slide-toggle [checked]="!!backgroundImageCover" (change)="backgroundImageCoverChange.emit($event.checked)">
        <span translate="PRESENTER.BACKGROUND_IMAGE_COVER"></span>
      </mat-slide-toggle>
    }
  </gb-image-upload-button>

  <mat-form-field>
    <mat-label>{{ 'PRESENTER.FONT_FAMILY' | translate }}</mat-label>
    <mat-select [formControl]="fontFamilyFormControl" (selectionChange)="fontFamilyChange.emit($event.value)">
      <mat-option [value]="''">{{ 'NONE' | translate }}</mat-option>
      @for (font of fontFamilyOptions; track font) {
        <mat-option [value]="font" [style.font-family]="font">{{ font }}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  <gb-token-color-picker
    circleDiameter="38px"
    [control]="fontColorFormControl"
    labelTranslateKey="PRESENTER.FONT_COLOR"
    (colorPickerClose)="fontColorChange.emit($event)"
    cpPosition="right"
    [showDropdown]="true"
  ></gb-token-color-picker>
</div>
